import React from 'react';
import './css/App.css';
import GUIBuilder from './GUI/formBuilder';

function App() {
  return (
    <div className="App">
      <GUIBuilder />
    </div>
  );
}

export default App;
